import axios from "axios";
import router from "../../router";

export const state = {
    // patient_saving: false,
    purchase_orders: [],
    purchase_order: [],
    items: [],
    generating_status:false,
};
export const getters = {
    purchaseOrders: state => state.purchase_orders.data,
    purchaseOrder: state => state.purchase_order,
    Items: state => state.items.data,
    GeneratingStatus: state => state.generating_status,
};

export const mutations = {
    SET_PURCHASE_ORDERS(state, newValue) {
        state.purchase_orders = newValue
    },
    SET_PURCHASE_ORDER(state, newValue) {
        state.purchase_order = newValue
    },
    SET_ITEMS(state, newValue) {
        state.items = newValue
    },
    GENERATING_STATUS(state, newValue) {
        state.generating_status = newValue
    }


};
export const actions = {
    fetchPurchaseOrderDetails({ commit },lpo) {
        axios.get(`purchase_orders/${lpo}`).then(lpo_res => {
            commit('SET_PURCHASE_ORDER', lpo_res.data)
        })
    },
    fetchPurchaseOrders({ commit }) {
        axios.get('purchase_orders').then(lpo_res => {
            commit('SET_PURCHASE_ORDERS', lpo_res.data)
        })
    },
    fetchItems({ commit }) {
        axios.get('purchase_orders').then(lpo_res => {
            commit('SET_PURCHASE_ORDERS', lpo_res.data)
        })
    },

    generateOrder({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('purchase_orders', payload).then(resp => {

            dispatch('fetchPurchaseOrders')
            commit('GENERATING_STATUS', false)
            let message = { 'msg': resp.data.msg }
            if (resp.status==200){
                // DISPATCH MESSAGE MODULE
                dispatch('notification/success', message, { root: true })
            }else {
                // DISPATCH MESSAGE MODULE
                dispatch('notification/error', message, { root: true })
            }
        }).catch(error_res => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': error_res.data.state_text }
            dispatch('notification/error', message, { root: true })
        })
    },
    addItem({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('add_purchase_order_items', payload).then(() => {
            dispatch('fetchPurchaseOrderDetails',payload.orderId)
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Item Added successfully" }
                dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Error adding Item" }
            dispatch('notification/error', message, { root: true })
        })
    },
    changeSupplier({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('change_purchase_order_supplier', payload).then(() => {
            dispatch('fetchPurchaseOrderDetails',payload.orderId)
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Supplier successfully changed" }
                dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Error adding Supplier" }
            dispatch('notification/error', message, { root: true })
        })
    },
    approveLPO({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('approve_lpo', payload).then(() => {
            dispatch('fetchPurchaseOrderDetails',payload.id)
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "LPO approved successfully" }
                dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Error Approving LPO" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteOrder({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.delete(`purchase_orders/${payload.id}`).then(resp => {
            dispatch('fetchPurchaseOrders')
            commit('GENERATING_STATUS', false)
            let message = { 'msg': resp.data.msg }
            if (resp.status==200){
                // DISPATCH MESSAGE MODULE
                dispatch('notification/success', message, { root: true })
            }else {
                // DISPATCH MESSAGE MODULE
                dispatch('notification/error', message, { root: true })
            }
        }).catch(error_res => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': error_res.data.state_text }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteItem({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('delete_purchase_order_item', payload).then(() => {
            dispatch('fetchPurchaseOrderDetails',payload.orderId)
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "LPO Item removed successfully" }
                dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Error removing LPO Item" }
            dispatch('notification/error', message, { root: true })
        })
    },


    addQuantity({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('add_quantity_received', payload).then(() => {
            dispatch('fetchPurchaseOrderDetails',payload.orderId)
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Supplied quantity of "+payload.item_name+" recorded successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Error adding Item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    LPOStocking({dispatch, commit}, payload){
        commit('GENERATING_STATUS', true)
        axios.post('lpo_stocking', payload).then(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Stocking successfully" }
            dispatch('notification/success', message, { root: true })
            router.push({name: 'LPOs'})
        }).catch(() => {
            commit('GENERATING_STATUS', false)
            let message = { 'msg': "Stocking Failed" }
            dispatch('notification/error', message, { root: true })
        })
    },
};